<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn_160" v-if="isScanSign == 1">
      <el-select
        class="select_btn_style"
        v-model="filters.signType"
        placeholder="签到类型"
      >
        <el-option
          v-for="(item, i) in signTypeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.userName"
        placeholder="姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
export default {
  components: {
    butn,
  },
  props: {
    isScanSign: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filters: {
      },
      signTypeList: [],
    };
  },
  created() {
    this.getSysParamByTypes(["SIGN_TYPE",]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["SIGN_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.signTypeList = res.data["SIGN_TYPE"] || [];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {
      };
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select__tags {
  overflow: hidden;
  span {
    display: flex;
  }
}
</style>
